import { render, staticRenderFns } from "./JudgesLayout.vue?vue&type=template&id=7040573a&scoped=true&"
import script from "./JudgesLayout.vue?vue&type=script&lang=js&"
export * from "./JudgesLayout.vue?vue&type=script&lang=js&"
import style0 from "./JudgesLayout.vue?vue&type=style&index=0&id=7040573a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7040573a",
  null
  
)

export default component.exports